import { render, staticRenderFns } from "./updateImg.vue?vue&type=template&id=6286d3f9"
import script from "./updateImg.vue?vue&type=script&lang=js"
export * from "./updateImg.vue?vue&type=script&lang=js"
import style0 from "./updateImg.vue?vue&type=style&index=0&id=6286d3f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports